import { useTranslation } from "react-i18next";
import Layout, { Section, PageHero } from "@/components/layout/Layout";
import { Reveal } from "@/components/common/Reveal";
import { ArrowUpRight } from "lucide-react";

export default function Solutions() {
    const { t } = useTranslation();
    const solutions = t("body.solutions.items", { returnObjects: true }) || [];
    return (
        <Layout title="Solutions — Ventara" description="AI Transformation, Enterprise AI, Voice AI, Agentic Systems, and more.">
            <PageHero i18nKey="solutions"
                eyebrow="Solutions"
                title={<>Ten practices,<br />one point of view.</>}
                lead="We help organizations move from AI curiosity to AI composure. What follows is not a menu — it is a description of how we work."
            />

            <Section className="pb-32">
                <div className="divide-y divide-border border-t border-b border-border">
                    {solutions.map((s) => (
                        <Reveal key={s.k}>
                            <div className="grid lg:grid-cols-12 gap-8 py-10 group hover:bg-muted/40 transition-colors" data-testid={`solution-${s.k}`}>
                                <div className="lg:col-span-2 label pt-2">{s.k}</div>
                                <div className="lg:col-span-4">
                                    <h3 className="font-serif text-3xl sm:text-4xl tracking-tight">{s.t}</h3>
                                </div>
                                <div className="lg:col-span-5 prose-body">
                                    <p>{s.d}</p>
                                    <p className="mt-3 text-sm">{s.detail}</p>
                                </div>
                                <div className="lg:col-span-1 flex items-start justify-end">
                                    <ArrowUpRight className="h-5 w-5 text-muted-foreground group-hover:text-foreground transition-colors" />
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </Section>
        </Layout>
    );
}
